import React from 'react'
import { Map } from 'immutable'
import type { SearchSort } from '../../services/community/oracle/useAiSearchStream'

export const SORT_OPTIONS = ['relevance', 'dateAdded', 'popularity', 'az'] as const
export type SortOption = typeof SORT_OPTIONS[number]

const SORT_GRAPHQL_MAP: Record<SortOption, SearchSort> = {
  relevance: 'RELEVANCE',
  dateAdded: 'DATE_ADDED',
  popularity: 'POPULARITY',
  az: 'A_Z',
}

interface SortBarProps {
  staticText: Map<string, unknown>
  sortMode: SortOption
  onSortChange: (sort: SortOption, graphqlSort: SearchSort) => void
  disabled?: boolean
}

export default function SortBar ({
  staticText,
  sortMode,
  onSortChange,
  disabled = false,
}: SortBarProps): React.ReactElement {
  return (
    <ul className="search-page__sort-list">
      {SORT_OPTIONS.map((option) => {
        const label = staticText.getIn(['data', option], option) as string
        const isActive = sortMode === option
        return (
          <li key={option} className="search-page__sort-item">
            <a
              role="button"
              tabIndex={0}
              className={
                `search-page__sort-btn${isActive ? ' search-page__sort-btn--active' : ''}`
              }
              aria-pressed={isActive}
              aria-disabled={disabled || undefined}
              onClick={disabled ? undefined : () => onSortChange(option, SORT_GRAPHQL_MAP[option])}
              onKeyDown={disabled ? undefined : (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  onSortChange(option, SORT_GRAPHQL_MAP[option])
                }
              }}
            >
              {label}
            </a>
          </li>
        )
      })}
    </ul>
  )
}
